import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyPayment = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [paymentList, setPaymentList] = useState<PaymentListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.payment, [location.search, userid, page]],
    () =>
      fetcher.mypage.postMyPaymentList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        pm: String(userid),  
        group: String(page),  
      }),
    {
      enabled: (page === 'pay1' || page === 'pay2'), 
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setPaymentList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: paymentHidden, isSuccess: hiddenPayment } = useMutation(
    [endpoints.mypage.paymenthidden],
    fetcher.mypage.postMyPaymentHidden,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            break;
        }
      },
    },
  )  

  return { paymentList, searchResult, refetch, paymentHidden, hiddenPayment };
};

export default useMyPayment;
